const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
const hostingerMode = import.meta.env.VITE_HOSTINGER_MODE === "true";

export function apiUrl(path: string): string {
  if (hostingerMode) {
    if (path === "/api/businesses" || path.startsWith("/api/businesses?")) {
      return path.replace(/^\/api\/businesses/, "/api/get_businesses.php");
    }
  }

  if (!rawApiBaseUrl) return path;
  return `${rawApiBaseUrl.replace(/\/$/, "")}${path}`;
}
